import { INVITATION_STATUS, REDUX_STORE } from '@funnels/constants';
import {
  ClearApplicantErrorAction,
  CreateApplicantAction,
  CreateApplicantFailAction,
  CreateApplicantSuccessAction,
  DeleteApplicantAction,
  DeleteApplicantFailAction,
  DeleteApplicantSuccessAction,
  Dependant,
  FetchApplicantsAction,
  FetchApplicantsFailAction,
  FetchApplicantsSuccessAction,
  ServerApplicantFetch,
  SetApplicantErrorAction,
  StoreApplicant,
  UpdateApplicantAbortAction,
  UpdateApplicantAction,
  UpdateApplicantFailAction,
  UpdateApplicantInvitationStatusAction,
  UpdateApplicantSuccessAction,
  UpsertApplicantsAction,
  UpsertApplicantsFailAction,
  UpsertApplicantsSuccessAction,
} from '@funnels/types';

export function clearApplicantError(): ClearApplicantErrorAction {
  return { type: REDUX_STORE.APPLICANTS.ACTION_TYPES.CLEAR_APPLICANT_ERROR };
}

export function createApplicant(
  applicationId: string,
  applicant: StoreApplicant,
  currentCustomerId?: string,
  isClone?: boolean,
  version?: number
): CreateApplicantAction {
  return {
    type: REDUX_STORE.APPLICANTS.ACTION_TYPES.CREATE_APPLICANT,
    applicant,
    applicationId,
    currentCustomerId,
    isClone,
    version,
  };
}

export function createApplicantFail(clientId: string, currentCustomerId?: string): CreateApplicantFailAction {
  return { type: REDUX_STORE.APPLICANTS.ACTION_TYPES.CREATE_APPLICANT_FAIL, clientId, currentCustomerId };
}

export function createApplicantSuccess(
  clientId: string,
  id: string,
  customerId: string,
  dependants: Dependant[],
  currentCustomerId?: string
): CreateApplicantSuccessAction {
  return {
    type: REDUX_STORE.APPLICANTS.ACTION_TYPES.CREATE_APPLICANT_SUCCESS,
    clientId,
    id,
    customerId,
    dependants,
    currentCustomerId,
  };
}

export function deleteApplicant(
  applicationId: string,
  clientId: string,
  id?: string,
  version?: number
): DeleteApplicantAction {
  return { type: REDUX_STORE.APPLICANTS.ACTION_TYPES.DELETE_APPLICANT, clientId, id, applicationId, version };
}

export function deleteApplicantFail(clientId: string): DeleteApplicantFailAction {
  return { type: REDUX_STORE.APPLICANTS.ACTION_TYPES.DELETE_APPLICANT_FAIL, clientId };
}

export function deleteApplicantSuccess(): DeleteApplicantSuccessAction {
  return { type: REDUX_STORE.APPLICANTS.ACTION_TYPES.DELETE_APPLICANT_SUCCESS };
}

export function fetchApplicants(
  applicationId: string,
  currentCustomerId?: string,
  version?: number
): FetchApplicantsAction {
  return { type: REDUX_STORE.APPLICANTS.ACTION_TYPES.FETCH_APPLICANTS, applicationId, currentCustomerId, version };
}

export function fetchApplicantsFail(): FetchApplicantsFailAction {
  return { type: REDUX_STORE.APPLICANTS.ACTION_TYPES.FETCH_APPLICANTS_FAIL };
}

export function fetchApplicantsSuccess(
  applicants: ServerApplicantFetch[],
  currentCustomerId?: string,
  version?: number
): FetchApplicantsSuccessAction {
  return { type: REDUX_STORE.APPLICANTS.ACTION_TYPES.FETCH_APPLICANTS_SUCCESS, applicants, currentCustomerId, version };
}

export function setApplicantError(message: string = 'Unknown error'): SetApplicantErrorAction {
  return { type: REDUX_STORE.APPLICANTS.ACTION_TYPES.SET_APPLICANT_ERROR, message };
}

export function updateApplicantInvitationStatus(
  applicantId: string,
  invitationStatus: INVITATION_STATUS
): UpdateApplicantInvitationStatusAction {
  return {
    type: REDUX_STORE.APPLICANTS.ACTION_TYPES.UPDATE_APPLICANT_INVITATION_STATUS,
    applicantId,
    invitationStatus,
  };
}

export function updateApplicant(
  applicationId: string,
  applicant: StoreApplicant,
  currentCustomerId?: string,
  version?: number
): UpdateApplicantAction {
  return {
    type: REDUX_STORE.APPLICANTS.ACTION_TYPES.UPDATE_APPLICANT,
    applicant,
    applicationId,
    currentCustomerId,
    version,
  };
}

export function updateApplicantFail(clientId: string, currentCustomerId?: string): UpdateApplicantFailAction {
  return { type: REDUX_STORE.APPLICANTS.ACTION_TYPES.UPDATE_APPLICANT_FAIL, clientId, currentCustomerId };
}

export function updateApplicantAbort(): UpdateApplicantAbortAction {
  return { type: REDUX_STORE.APPLICANTS.ACTION_TYPES.UPDATE_APPLICANT_ABORT };
}

export function updateApplicantSuccess(
  id: string,
  dependants: Dependant[],
  currentCustomerId?: string
): UpdateApplicantSuccessAction {
  return { type: REDUX_STORE.APPLICANTS.ACTION_TYPES.UPDATE_APPLICANT_SUCCESS, id, dependants, currentCustomerId };
}

export function upsertApplicants(
  applicationId: string,
  applicants: StoreApplicant[],
  currentCustomerId?: string,
  version?: number
): UpsertApplicantsAction {
  return {
    type: REDUX_STORE.APPLICANTS.ACTION_TYPES.UPSERT_APPLICANTS,
    applicants,
    applicationId,
    currentCustomerId,
    version,
  };
}

export function upsertApplicantsFail(): UpsertApplicantsFailAction {
  return { type: REDUX_STORE.APPLICANTS.ACTION_TYPES.UPSERT_APPLICANTS_FAIL };
}

export function upsertApplicantsSuccess(): UpsertApplicantsSuccessAction {
  return { type: REDUX_STORE.APPLICANTS.ACTION_TYPES.UPSERT_APPLICANTS_SUCCESS };
}
